// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__DJcXJ","toggle":"style_toggle__0nzzp","toggle_btn":"style_toggle_btn__8Yp42"};